(function () {
    'use strict';

    angular
        .module('skillsApp')
        .factory('modalDialogService', modalDialogService)
        .controller('ModalDialogController', ModalDialogController);

    function modalDialogService($log, $uibModal, $translate) {
        var service = {
            alert: alert,
            confirmDelete: confirmDelete,
            confirmOk: confirmOk,
            confirmYesNo: confirmYesNo,
            open: open,
            
            openAddClusterActionDialog: openAddClusterActionDialog,
            openAddExaminersDialog: openAddExaminersDialog,
            openAddIndividualsDialog: openAddIndividualsDialog,
            openAssetsDownloadDialog: openAssetsDownloadDialog, 
            openChangeClusterActionClusterDialog: openChangeClusterActionClusterDialog,
            openEditClusterDialog: openEditClusterDialog,
            openExaminerSelectionDialog: openExaminerSelectionDialog,
            openExemptionDialog: openExemptionDialog,
            openImportExportExaminerAssignmentsDialog: openImportExportExaminerAssignmentsDialog,
            openManageExaminersDialog: openManageExaminersDialog,
            openMarkDialog: openMarkDialog,
            openReportDetailsDialog: openReportDetailsDialog,
            openSelectDepartmentFunctionsDialog: openSelectDepartmentFunctionsDialog,
            openSelectFunctionsDialog: openSelectFunctionsDialog,
            openSelectIdentitiesDialog: openSelectIdentitiesDialog,
        };

        return service;

        function alert(title, text, buttons) {

            if (!buttons) {
                buttons = {
                    buttonSet: [
                        {
                            buttonText: 'ok',
                            callbackFunction: function () {
                                $log.info('ok clicked');
                            },
                            buttonStyle: 'btn-primary'
                        }
                    ]
                };
            }

            return $uibModal.open({
                animation: true,
                backdrop: 'static',
                keyboard: false,
                ariaLabelledBy: 'modal-title',
                ariaDescribedBy: 'modal-body',
                templateUrl: '/app/services/modal-dialog/modal-dialog.tpl.html',
                controller: 'ModalDialogController',
                controllerAs: 'vm',
                resolve: {
                    title: function () {
                        return title;
                    },
                    text: function () {
                        return $translate.instant(text);
                    },
                    buttons: function () {
                        return buttons;
                    }
                }
            });
        }
        
        function confirmDelete(title, text, onOk, onCancel) {
            var modalWindow = {
                buttonSet: [{
                    buttonText: 'delete',
                    callbackFunction: onOk,
                    buttonStyle: 'btn-danger'
                }],
                cancelButton: {
                    buttonText: 'cancel',
                    callbackFunction: onCancel,
                    buttonStyle: 'btn-default'
                }
            };

            return service.alert(title, text, modalWindow).result;
        }

        function confirmOk(title, text, onOk, onCancel) {
            var modalWindow = {
                buttonSet: [{
                    buttonText: 'ok',
                    callbackFunction: onOk,
                    buttonStyle: 'btn-primary'
                }],
                cancelButton: {
                    buttonText: 'cancel',
                    callbackFunction: onCancel,
                    buttonStyle: 'btn-default'
                }
            };

            return service.alert(title, text, modalWindow).result;
        }

        function confirmYesNo(title, text, onYes, onNo) {
            var modalWindow = {
                buttonSet: [{
                    buttonText: 'yes',
                    callbackFunction: onYes,
                    buttonStyle: 'btn-primary'
                }],
                cancelButton: {
                    buttonText: 'no',
                    callbackFunction: onNo,
                    buttonStyle: 'btn-default'
                }
            };

            return service.alert(title, text, modalWindow).result;
        }

        function open(templateUrl, controller, resolve) {
            return $uibModal.open({
                animation: true,
                backdrop: 'static',
                keyboard: false,
                ariaLabelledBy: 'modal-title',
                ariaDescribedBy: 'modal-body',
                templateUrl: templateUrl,
                controller: controller,
                controllerAs: 'vm',
                size: 'lg',
                resolve: resolve
            });
        }
        
        function openAddClusterActionDialog(cluster) {
            return service.open('/app/dialogs/create-clusteraction-dialog.tpl.html', 'CreateClusterActionDialogController', {
                cluster: function () {
                    return cluster;
                }
            }).result;
        }

        function openAddExaminersDialog(activity) {
            return service.open('/app/dialogs/add-examiners-dialog.tpl.html', 'AddExaminersDialogController', {
                activity: function () {
                    return activity;
                }
            }).result;
        }

        function openAddIndividualsDialog() {
            return service.open('/app/dialogs/add-individuals-dialog.tpl.html', 'AddIndividualsDialogController').result;
        }

        function openAssetsDownloadDialog(userQuality) {
            return service.open('/app/dialogs/assets-download-dialog.tpl.html', 'AssetsDownloadDialogController', {
                userQuality: function () {
                    return userQuality;
                }
            }).result;
        }

        function openChangeClusterActionClusterDialog(clusterAction) {
            return service.open('/app/dialogs/change-clusteraction-cluster-dialog.tpl.html', 'ChangeClusterActionClusterDialogController', {
                clusterAction: function () {
                    return angular.copy(clusterAction);
                }
            }).result;
        }

        function openEditClusterDialog(cluster) {
            return service.open('/app/dialogs/edit-cluster-dialog.tpl.html', 'EditClusterDialogController', {
                cluster: function () {
                    return cluster;
                }
            }).result;
        }

        function openExaminerSelectionDialog(userQuality, activity) {
            return service.open('/app/dialogs/examiner-selection-dialog.tpl.html', 'ExaminerSelectionDialogController', {
                userQuality: function () {
                    return userQuality;
                },
                activity: function () {
                    return activity;
                }
            }).result;
        }

        function openExemptionDialog(userQuality) {
            return service.open('/app/dialogs/exemption-dialog.tpl.html', 'ExemptionDialogController', {
                userQuality: function () {
                    return userQuality;
                }
            }).result;
        }

        function openImportExportExaminerAssignmentsDialog(identity, isImport) {
            return service.open('/app/dialogs/import-export-examiner-assignments-dialog.tpl.html', 'ImportExportExaminerAssignmentsDialogController', {
                identity: function () {
                    return identity;
                },
                isImport: function () {
                    return isImport;
                }
            }).result;
        }

        function openManageExaminersDialog(activity) {
            return service.open('/app/dialogs/manage-examiners-dialog.tpl.html', 'ManageExaminersDialogController', {
                examiners: () => {
                    return activity.examiners;
                }
            }).result;
        }

        function openMarkDialog(activity) {
            return service.open('/app/dialogs/mark-dialog.tpl.html', 'MarkDialogController', {
                activity: function () {
                    return activity;
                }
            }).result;
        }

        function openReportDetailsDialog(params) {
            return service.open('/app/dialogs/report-details-dialog.tpl.html', 'ReportDetailsDialogController', {
                params: () => { return params; }
            }).result;
        }

        function openSelectDepartmentFunctionsDialog() {
            return service.open('/app/dialogs/select-department-functions-dialog.tpl.html', 'SelectDepartmentFunctionsDialogController').result;
        }

        function openSelectFunctionsDialog(clusterAction) {
            return service.open('/app/dialogs/select-functions-dialog.tpl.html', 'SelectFunctionsDialogController').result;
        }

        function openSelectIdentitiesDialog() {
            return service.open('/app/dialogs/select-identities-dialog.tpl.html', 'SelectIdentitiesDialogController').result;
        }
    }

    function ModalDialogController($uibModalInstance, title, text, buttons) {
        var vm = this;

        vm.title = title;
        vm.text = text;
        vm.buttons = buttons;

        vm.btnClicked = btnClicked;
        vm.cancel = cancel;

        function btnClicked(callback) {
            $uibModalInstance.close();
            if (callback) {
                callback();
            }
        }

        function cancel() {
            $uibModalInstance.dismiss('cancel');
            if (vm.buttons.cancelButton && vm.buttons.cancelButton.callbackFunction) {
                vm.buttons.cancelButton.callbackFunction();
            }
        }
    }
}());
